import { HorizontalScrollBox } from '../../../../common/components/HorizontalScrollBox/HorizontalScrollBox';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { Action, TelehealthActionCard } from './TelehealthAction/TelehealthAction';
import {
  TelehealthActionsCardContainer,
  CalendarTodayIconStyled,
  DescriptionIconStyled,
  ScheduleIconStyled,
  DevicesOtherOutlinedStyled,
  TelehealthActionsInfoCTA,
  TelehealthActionsInfoCTAContentWrapper,
  InfoOutlinedStyled,
  TelehealthActionsInfoCTALabel,
  TelehealthActionsAdventureTime,
} from './TelehealthActions.styles';

export const FLAGR_TELEHEALTH_GP_SEARCH_CARDS = 'kyqgswo18uc9i3xnn';

const actions: Action[] = [
  {
    title: 'Learn more about telehealth',
    description: 'Get your healthcare via phone, video or form-based medicine',
    icon: <DevicesOtherOutlinedStyled />,
    iconColour: ThemeColours.primary700,
    iconBackgroundColour: ThemeColours.white,
    route: 'https://services.healthengine.com.au/telehealth-gp-options?source=gp-tele-search',
    highlight: true,
  },
  {
    title: 'Certificates and Prescriptions',
    description:
      'Submit your request via an online form. No waiting or talking; results in minutes.',
    icon: <DescriptionIconStyled />,
    iconColour: ThemeColours.primary700,
    iconBackgroundColour: ThemeColours.primary50,
    price: 15,
    route: '/services/telehealth/instantscripts-selection?source=gp-tele-search',
  },
  {
    title: 'On demand consult',
    description: 'See the next available doctor, average wait time under 15 minutes.',
    subTitle: 'Max 8 mins consult',
    icon: <ScheduleIconStyled />,
    iconColour: ThemeColours.black,
    iconBackgroundColour: ThemeColours.mono100,
    price: 39,
    route: '/v2/appointment/book/89976/General%20Practice/today?source=gp-tele-search',
  },
  {
    title: 'Scheduled consult',
    subTitle: 'Max 15 mins consult',
    description: 'Book with your choice of doctor* and time for up to 15 minutes.',
    icon: <CalendarTodayIconStyled />,
    iconColour: ThemeColours.accent500,
    iconBackgroundColour: ThemeColours.accent50,
    price: 52,
    route: '/services/telehealth/appointments?source=gp-tele-search',
  },
];

export interface TelehealthActionsProps {
  variation?: TelehealthActionsVariations;
}

export type TelehealthActionsVariations = 'vertical' | 'horizontal' | 'colour-splash';

export const TelehealthActions = ({ variation = 'horizontal' }: TelehealthActionsProps) => (
  <>
    <TelehealthActionsAdventureTime>
      Telehealth only services
      <TelehealthActionsInfoCTA
        label={TelehealthActionsInfoCTALabelContent}
        description={TelehealthActionsInfoCTAContent}
      />
    </TelehealthActionsAdventureTime>

    <TelehealthActionsCardContainer>
      <HorizontalScrollBox variation={variation}>
        {actions.map((a, i) => (
          <TelehealthActionCard key={i} {...a} variation={variation} />
        ))}
      </HorizontalScrollBox>
    </TelehealthActionsCardContainer>
  </>
);

const TelehealthActionsInfoCTALabelContent = (
  <TelehealthActionsInfoCTAContentWrapper>
    <InfoOutlinedStyled />
    <TelehealthActionsInfoCTALabel as="p">
      How we order these search results?
    </TelehealthActionsInfoCTALabel>
  </TelehealthActionsInfoCTAContentWrapper>
);

const TelehealthActionsInfoCTAContent = (
  <>
    There are many GP Telehealth options available on our site and we want to make your search
    results as relevant to you as possible. That’s why our GP Telehealth options are presented
    differently by grouping results into two groups, Telehealth only services and local GP practices
    offering Telehealth services near a specific location.
    <br />
    <br />
    <i>
      The "filter" settings allows you to include or exclude various options based on your health
      needs.
    </i>
    <br />
    <br />
    <b>Telehealth only services</b>
    <br />
    Telehealth only services refers to service providers that only offer a Telehealth service with
    no in person service offering. These results appear at the top of GP Telehealth search results
    unless excluded by a filter. HealthEngine has partnered with and receives commission fees from
    these partners.
    <br />
    <br />
    <b>Local GP Telehealth services near a specific location</b>
    <br />
    These results are physical local GP Practices that offer telehealth services in addition to
    in-person consults. These results appear below the telehealth only services results. We use
    complex, dynamic algorithms to ensure your search results are ordered efficiently. We measure
    relevance by taking into account factors such as the distance from the search location, next
    available appointment time and any other search criteria provided.
    <br />
    <br />
    From time to time, we may test changes in the search algorithm.
  </>
);
